import editor from "./editor";
import commonHelpers from "common/plugins/issues/topic_not_present_with_parameter";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
